import {
  FILTER_LOADING,
  FILTER_ERROR,
  FILTER_INIT,
  FILTER_POP,
  FILTER_PUSH,
  FILTER_RESET
} from '../actions/filter';

export const initialFilterState = {
  isLoading: false,
  error: false,
  filteredValues: [],
  filteredTags: []
};

const getState = function(state = initialFilterState, action) {
  switch (action.type) {
    case FILTER_LOADING:
      return {
        ...state,
        isLoading: action.loading
      };
    case FILTER_ERROR:
      return {
        ...state,
        error: true
      };
    case FILTER_INIT:
      return {
        ...state,
        [action.key]: action.value
      };
    case FILTER_POP:
      return {
        ...state,
        [action.key]: state[action.key].filter(item => item !== action.value)
      };
    case FILTER_PUSH:
      return {
        ...state,
        [action.key]: [...state[action.key], action.value]
      };

    case FILTER_RESET:
      return {
        ...state,
        [action.key]: initialFilterState[action.key]
      };
    default:
      return state;
  }
};
export default getState;
